import { forwardRef, type Ref, type SVGProps } from "react";
function SvgDrivingError(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#driving-error_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#driving-error_svg__b)" strokeWidth={20} />
      </g>
      <g clipPath="url(#driving-error_svg__c)">
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.667}
          d="m71.26 57.5 4.292-7.52a4.87 4.87 0 0 1 4.225-2.48h13.946c1.74 0 3.349.945 4.225 2.48l4.291 7.52m-30.978 0H68m3.26 0V70c0 1.38 1.096 2.5 2.447 2.5s2.445-1.12 2.445-2.5v-.833h21.196V70c0 1.38 1.095 2.5 2.445 2.5 1.351 0 2.446-1.12 2.446-2.5V57.5m0 0h3.261m-29.348 3.333h3.261m14.674 0h3.26"
        />
      </g>
      <rect width={39} height={39} x={33} y={10.5} fill="#B01921" rx={19.5} />
      <rect width={39} height={39} x={33} y={10.5} stroke="#fff" rx={19.5} />
      <g clipPath="url(#driving-error_svg__d)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M49.84 23.318c1.222-1.975 4.095-1.975 5.316 0l5.307 8.58c1.287 2.082-.21 4.769-2.658 4.769H47.193c-2.448 0-3.946-2.687-2.658-4.769zm2.66 3.349c.345 0 .625.28.625.625v3.333a.625.625 0 1 1-1.25 0v-3.333c0-.346.28-.625.625-.625m.833 6.25a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="driving-error_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
        <clipPath id="driving-error_svg__c">
          <path fill="#fff" d="M68 40h40v40H68z" />
        </clipPath>
        <clipPath id="driving-error_svg__d">
          <path fill="#fff" d="M42.5 20h20v20h-20z" />
        </clipPath>
        <linearGradient
          id="driving-error_svg__b"
          x1={88}
          x2={87.57}
          y1={10}
          y2={85.533}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDrivingError);
export default ForwardRef;
